export default __webpack_public_path__ + "static/summer_containers57-d0e7a3521f351fcfde7401033f462266.webp";